import {createSelector} from "@reduxjs/toolkit";
import {ReducerStatuses} from "services/utils/utils";

const baseState = state => state.home;

export const getHomeData = createSelector([baseState], (state) => {
    const data = state.data;
    return {
        video: Object.values(data.video),
        recent_video: Object.values(data.recent_video),
        category_video: {
            category: data.category_video.category,
            list: Object.values(data.category_video.list)
        },
        directory_video: Object.values(data.directory_video || {}),
        events: Object.values(data.events),
        cta: Object.values(data.cta),
        workouts: Object.values(data.workouts),
        threads: Object.values(data.threads),
        users: Object.values(data.users),
        companies: Object.values(data.companies)
    }
});

export const getHomeDataLoading = createSelector([baseState, getHomeData], (state, home_data) => {
    return state.status === ReducerStatuses.LOADING && !home_data.video.length;
});

export const getHomeDataError = createSelector([baseState], (state) => {
    return {
        inError: state.status === ReducerStatuses.ERROR,
        error: state.error
    };
});


